export default "data:image/webp;base64,UklGRiwAAABXRUJQVlA4TB8AAAAvJ4AGACAasLDLna5rpP4LBAjKpev/BKAoxX252nyDAA=="